/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2025 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React, { useState, useEffect } from 'react'
import { getSession } from '@/services/session'
import { Outlet, useLocation } from 'react-router-dom'
import { useAuth0 } from '@auth0/auth0-react'
import { AuthContext } from './auth-context'
import { getProcesses } from '@/services/processes'
import ScreenLoader from '@/components/loaders/ScreenLoader'

const SessionProvider = ({ children }) => {
  const { getAccessTokenSilently } = useAuth0()
  const location = useLocation()
  const [sessionData, setSessionData] = useState({})
  const [auth, setAuth] = useState(false)
  const getUserSession = async () => {
    try {
      const accessToken = await getAccessTokenSilently()
      const session = await getSession(accessToken)
      const isAuth = session.logged

      setAuth(true)
      setSessionData(session.logged
        ? session
        : { isAuth }
      )
    } catch (error) {
      console.error('Error getting user session:', error)
    }
  }
  const getCurrentProcesses = async () => {
    try {
      const { data: notifications } = await getProcesses(getAccessTokenSilently)
      setSessionData(prevSession => ({
        ...prevSession,
        notifications: notifications || []
      }))
    } catch (error) {
      console.error('Error fetching notifications:', error)
    }
  }

  const updateNotifications = (newNotifications) => {
    setSessionData(prevSession => ({
      ...prevSession,
      notifications: newNotifications
    }))
  }

  useEffect(() => {
    getUserSession()
  }, [])

  useEffect(() => {
    if (auth && sessionData.auth0UserId) {
      getCurrentProcesses()
    }
  }, [location.pathname, auth])

  const contextValue = {
    ...sessionData,
    getCurrentProcesses,
    updateNotifications
  }

  return (
    <AuthContext.Provider value={contextValue}>
      { auth
        ? children || <Outlet />
        : <ScreenLoader />
      }
    </AuthContext.Provider>
  )
}

export default SessionProvider
